<template>
  <!-- 首页-数据看板-专利保护状态-饼图 -->
  <div ref="myChart"
       :style="{margin: '0 auto',width: '100%', height: '100%'}"></div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {
    echartDatas: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
  },
  created () {
  },
  mounted () {
    this.drawChart()
  },
  methods: {
    drawChart () {
      // this.$refs.myChart.removeAttribute("_echarts_instance_");
      // document.getElementById('echartLine').removeAttribute("_echarts_instance_");
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.myChart, 'light')
      let seriesDatas = []
      for (let i = 0; i < this.echartDatas.length; i++) {
        seriesDatas.push({
          name: this.echartDatas[i].name,
          value: this.echartDatas[i].count
        })
      }
      // 指定图表的配置项和数据
      let option = {
        title: {
          text: "专利保护状态",
          x: "center",
          y: 0,
          textStyle: {
            fontSize: 18,
            fontWeight: "normal",
            color: "#ffffff"
          }
        },
        color: ["#5470c6", "#3ba272", "#ee6666"],
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: "70%",
            center: ["50%", "60%"],
            label: {
              // alignTo: 'labelLine',
              formatter: "{name|{b}}\n{value|{c}件}",
              minMargin: 0,
              edgeDistance: 0,
              // width: 100,
              distanceToLabelLine: -45,
              lineHeight: 15,
              rich: {
                textStyle: {
                  color: "#000000",
                  fontsize: 14
                }
              },
              textStyle: {
                fontSize: 14,
                fontWeight: "normal",
                color: "#ffffff"
              }
            },
            labelLine: {
              show: false,
              length: 5,
              length2: 20,
              lineStyle: {
                width: 1
              },
              maxSurfaceAngle: 80
            },
            data: seriesDatas
            // data: [
            //   { value: 53569, name: '未授权' },
            //   { value: 19954, name: '有效' },
            //   { value: 8706, name: '已失效' }
            // ]
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    }
  },
  watch: {
    echartDatas: {
      handler () { // val, oldVal
        // console.log('当数量变化时重新绘制图表')//但是这两个值打印出来却都是一样的
        this.drawChart()
      }
    }
  }
}
</script>

<style>
</style>
